/**
 * Created by andrey on 09.02.2021.
 */

const Map2dDecorator = function (options) { 
    Object.assign(this, options);

    // migration
    if (this.scale) {
        this.scaleY = this.scale;
        this.scaleX = this.scale;
    }

    this.lastSmile = 0;
    this.visible = true;

    this.isOnScreen = function () {};
    this.onSmile = function () {};
    this.getView = function () {};
    this.onSetSkin = function () {};
    this.onRemove = function () {};
    this.onSetAnimation = function () {};
    this.onAnimateHover = function () {};
    this.onStopAnimateHover = function () {};
    this.onSetVisible = function () {};
};

Map2dDecorator.prototype.setVisible = function (visible) {
    this.visible = visible;
    this.onSetVisible();
};

Map2dDecorator.prototype.getLayerId = function () {
    const map = Map2d.currentMap;
    const groundOnly = cleverapps.meta.getSelectedLocation().locationConfig.groundOnlyDecorators;

    if (this.layer !== undefined) {
        return this.layer;
    }

    if (map.layers[Map2d.LAYER_GROUND][this.y][this.x] !== undefined || groundOnly) {
        return this.code.indexOf("grounddecorator_") !== -1 ? Map2d.LAYER_GROUND : Map2d.ABOVE_GROUND;
    }

    return Map2d.BORDERS ? Map2d.LAYER_BORDERS : Map2d.LAYER_WATER;
};

Map2dDecorator.prototype.hasSmile = function () {
    if (Map2dDecorator.smilesCache[this.code] === undefined) {
        Map2dDecorator.smilesCache[this.code] = false;

        const json = Map2dDecoratorView.getJson(this);
        if (cleverapps.config.debugMode && json && !json.resolve()) {
            throw `Name ${this.code} already used for spine decorator. Please rename sprite decorator ${this.code}`;
        }

        if (json) {
            const data = json.resolve().getJson();
            if (data && data.animations && data.animations.smile) {
                Map2dDecorator.smilesCache[this.code] = true;
            }
        }
    }
    return Map2dDecorator.smilesCache[this.code];
};

Map2dDecorator.prototype.isDynamic = function () {
    return this.dynamic;
};

Map2dDecorator.prototype.isLarge = function () {
    return this.largeBox !== undefined;
};

Map2dDecorator.prototype.getCellRect = function () {
    if (this.cellRect) {
        return this.cellRect;
    }

    const styles = cleverapps.styles.Map2dView.cell;
    const position = Map2d.currentMap.getMapView().alignInGrid(this.x, this.y);
    const cellRect = cc.rect(position.x - styles.width / 2, position.y - styles.height / 2, styles.width, styles.height);

    if (!cleverapps.config.editorMode) {
        this.cellRect = cellRect;
    }

    return cellRect;
};

Map2dDecorator.prototype.getLargeBox = function () {
    if (this.alignedLargeBox) {
        return this.alignedLargeBox;
    }

    const position = Map2d.currentMap.getMapView().alignInGrid(this.x, this.y);
    const alignedLargeBox = cc.rect(
        position.x + Math.floor(this.largeBox.x * resolutionScale),
        position.y + Math.floor(this.largeBox.y * resolutionScale),
        Math.ceil(this.largeBox.width * resolutionScale),
        Math.ceil(this.largeBox.height * resolutionScale)
    );

    if (!cleverapps.config.editorMode) {
        this.alignedLargeBox = alignedLargeBox;
    }

    return alignedLargeBox;
};

Map2dDecorator.prototype.canSmile = function () {
    if (!this.hasSmile() || Date.now() <= this.lastSmile + Map2dDecorator.SMILE_TIMEOUT || !this.isOnScreen()) {
        return false;
    }

    const fog = Map2d.currentMap.getFog(this.x, this.y);
    if (fog && [FogBlock.UNAVAILABLE, FogBlock.NOTREADY].indexOf(fog.fogBlock.state) !== -1) {
        return false;
    }

    return true;
};

Map2dDecorator.prototype.smile = function () {
    this.lastSmile = Date.now();
    this.onSmile();
};

Map2dDecorator.prototype.setSkin = function (skin, silent) {
    if (this.skin === skin) {
        return;
    }
    this.skin = skin;
    this.onSetSkin(skin, silent);
};

Map2dDecorator.prototype.getSkin = function () {
    return this.skin;
};

Map2dDecorator.prototype.setAnimation = function (animation, silent, options) {
    options = options || {};
    const callback = options.callback || function () {};
    if (this.animation === animation) {
        callback();
        return;
    }
    this.animation = animation;

    if (!this.getView()) {
        callback();
        return;
    }
    this.onSetAnimation(animation, silent, options);
};

Map2dDecorator.prototype.getAnimation = function () {
    return this.animation;
};

Map2dDecorator.prototype.onClickEvent = function () {

};

Map2dDecorator.prototype.checkTouchInside = function (touch) {
    const view = this.getView();
    if (view) {
        return view.checkTouchInside(touch);
    }
};

Map2dDecorator.prototype.animateHover = function () {
    this.onAnimateHover();
};

Map2dDecorator.prototype.stopAnimateHover = function () {
    this.onStopAnimateHover();
};

Map2dDecorator.prototype.createView = function () {
    const map = Map2d.currentMap;
    const mapView = map.getMapView();

    map.setPointer(this.x, this.y);

    const ViewClass = this.getViewClass();

    const view = new ViewClass(this);

    mapView.addTile(this.getLayerId(), this.x, this.y, view);
    return view;
};

Map2dDecorator.prototype.getLocalZOrder = function () {
    if (this.zOrder !== undefined) {
        return this.zOrder;
    }
    return this.decoratorZIndex || 1;
};

Map2dDecorator.prototype.getViewClass = function () {
    return Map2dDecoratorView;
};

Map2dDecorator.prototype.isClimbable = function () {
    return Map2dDecorators.CLIMBABLE_TRIGGERS[cleverapps.meta.selectedLocationId()]
        && Map2dDecorators.CLIMBABLE_TRIGGERS[cleverapps.meta.selectedLocationId()][this.code];
};

Map2dDecorator.SMILE_TIMEOUT = cleverapps.parseInterval("3 seconds");

Map2dDecorator.smilesCache = {};